import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { DckLogo } from "../../components/DCKeeper/ui/DckLogo";

/**
 * 認證頁外殼 —— 對齊 Figma DCK-00_共用「外部 WF」的登入(2128:21427)與
 * 重設密碼(2128:21460):滿版淺色底 + 中央單張白卡,不再走模板 auth-login
 * 的「左表單/右輪播」分欄。login / recoverpw / reset-password 三頁共用。
 *
 * 卡片內結構(對齊 Figma 428×722):
 *   logo → title → subtitle → 內容(表單或 alert)→ 卡底 Copyright
 * 背景 pattern 因 Figma 原圖無法透過 proxy 取檔,以 SVG data-URI 做近似的
 * 淡色四分之一圓花瓣重複紋,視覺份量與設計稿一致。
 */
const AuthShell = ({ title, subtitle, children }) => {
  useEffect(() => {
    document.body.classList.add("dck-auth-body");
    return () => { document.body.classList.remove("dck-auth-body"); };
  }, []);

  return (
    <div className="dck-auth-page">
      <div className="dck-auth-card">
        <div className="dck-auth-card-body">
          <div className="text-center">
            <Link to="/auth-login" className="d-inline-block">
              {/* 白底卡片用彩色字標(Figma logo_彩色 29:2990;客戶原件 dckeeper-logo_colorful.svg) */}
              <DckLogo height={25.27} variant="color" />
            </Link>
          </div>
          {title ? (
            <div className="text-center mt-4">
              <h5 className="mb-0 fw-bold">{title}</h5>
              {subtitle ? <p className="text-muted mt-2 mb-0">{subtitle}</p> : null}
            </div>
          ) : null}
          <div className="dck-auth-content">{children}</div>
        </div>
        <div className="dck-auth-card-footer">
          © {new Date().getFullYear()} Copyright by DC Keeper.
        </div>
      </div>
    </div>
  );
};
AuthShell.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default AuthShell;
